"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proficiency = void 0;
exports.proficiency = {
    NOT_PROFICIENT: 'Not Yet Proficient',
    PARTIALLY_PROFICIENT: 'Partially Proficient',
    PROFICIENT: 'Proficient',
    HIGHLY_PROFICIENT: 'Highly Proficient',
};
//# sourceMappingURL=proficiency-criteria.enum.js.map